<template>
  <div class="whatsapp-button">
    <a
      :href="whatsappLink"
      target="_blank"
      rel="noopener noreferrer"
      class="whatsapp-link"
    >
      <div class="whatsapp-icon-wrapper">
        <div class="whatsapp-icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.1 0-65.6-8.9-93.9-25.7l-6.7-4-69.8 18.3 18.7-68.1-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-5.5-2.8-23.4-8.6-44.6-27.5-16.4-14.7-27.5-32.8-30.7-38.4-3.2-5.6-.3-8.6 2.5-11.4 2.5-2.5 5.5-6.5 8.3-9.7 2.8-3.3 3.7-5.5 5.5-9.3 1.9-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 13.2 5.8 23.5 9.2 31.5 11.8 13.3 4.2 25.4 3.6 35 2.2 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" fill="#fff"/>
          </svg>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'WhatsApp',
  data() {
    return {
      phoneNumber: '+918090549054',
    };
  },
  computed: {
    whatsappLink() {
      return `https://wa.me/${this.phoneNumber}`;
    },
  },
};
</script>

<style scoped>
.whatsapp-button {
  position: fixed;
  bottom: 100px;
  left: 20px;
  z-index: 9999;
}

.whatsapp-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.whatsapp-icon-container {
  width: 64px;
  height: 64px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.whatsapp-icon-container svg {
  width: 34px;
  height: 34px;
}

.whatsapp-icon-wrapper:hover .whatsapp-icon-container {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}

@media (max-width: 768px) {
  .whatsapp-button {
    bottom: 110px;
    left: 15px;
  }
  .whatsapp-icon-container {
    width: 60px;
    height: 60px;
  }
  .whatsapp-icon-container svg {
    width: 32px;
    height: 32px;
  }
}
</style>
  